// Romanian translations for the application

/*Ce scrii	Ce apare
**text** -> îngroșat
*text* -> înclinat
__text__ -> subliniat
rând gol între fraze -> paragraf nou, cu spațiu
un singur '\n' -> doar rând nou, fără spațiu
*/

export const t = {
  // Common
  common: {
    loading: 'Se încarcă...',
    error: 'Eroare',
    success: 'Succes',
    save: 'Salvează',
    cancel: 'Anulează',
    delete: 'Șterge',
    edit: 'Editează',
    add: 'Adaugă',
    search: 'Caută',
    filter: 'Filtrează',
    close: 'Închide',
    done: 'Gata',
    submit: 'Trimite',
    yes: 'Da',
    no: 'Nu',
    back: 'Înapoi',
    next: 'Următor',
    previous: 'Anterior',
    view: 'Vezi',
    viewAll: 'Vezi tot',
    details: 'Detalii',
    actions: 'Acțiuni',
    created: 'Creat',
    updated: 'Actualizat',
    showMore: 'Arată mai mult',
    showLess: 'Arată mai puțin',
    confirm: 'Confirmă'
  },

  // Auth
  auth: {
    roleUpdated: 'Rolul tău a fost actualizat în: {{role}}.',
    permissionDenied: 'Nu ai permisiunea necesară pentru această acțiune.',
    notAuthenticated: 'Trebuie să fii autentificat.',
  },

  // Navigation
  navigation: {
    dashboard: 'Panou de Control',
    cases: 'Cazuri',
    calendar: 'Calendar',
    counselors: 'Consilieri',
    sessionReports: 'Rapoarte',
    meetingNotes: 'Jurnalul sesiunii',
    adminTools: 'Unelte Admin',
    myProfile: 'Profilul Meu',
    resources: 'Resurse',
    logout: 'Deconectare',
    login: 'Conectare',
    signIn: 'Autentificare',
    profile: 'Profil'
  },

  tutorial: {
    menuLabel: 'Tutorial',
    dialogLabel: 'Tutorial Consiliere360',
    stepProgress: 'Pasul {current} din {total}',
    continue: 'Continuă',
    skip: 'Sari peste',
    later: 'Mai târziu',
    welcomeTitle: 'Bine ai venit, {name}',
    welcomeBody:
      'Prima dată aici? Îți arătăm în câțiva pași cum adaugi rapoarte și note și cum citești bara de sesiuni.',
    start: 'Începe tutorialul',
    steps: {
      welcome: {
        title: 'Bun venit în Consiliere360',
        body:
          'În câteva clickuri vezi cum ții evidența unui caz, adaugi rapoarte, note, programezi sesiuni, vizualizezi calendarul și accesezi resursele.',
        reports: 'Rapoarte: lunar și după fiecare sesiune',
        notes: 'Note rapide și tabloul întâlnirii, în Jurnalul sesiunii',
        prepare: 'Aprofundează — pregătești sesiunea direct din Cazuri',
        road: 'Bara de sesiuni de pe fiecare caz',
        calendarResources: 'Calendar și resurse',
      },
      monthly: {
        title: 'Raportul lunar',
        body:
          '**O dată pe lună trimiți un raport despre tine, nu despre cazuri.**\n\nÎl găsești în **Acțiuni rapide** din *Dashboard* și ca **+ Raport lunar** în bara de sus, lângă notificări. Pe telefon, același buton e jos în meniul din stânga.',
        topbar: 'Bara de sus',
        quickActions: 'Acțiuni rapide',
      },
      report: {
        title: 'Raportul după sesiune',
        body:
          'Raportul este pasul care marchează sesiunea ca încheiată.\n\nÎl găsești ca **+ Raport** pe cardul de caz din *Dashboard* sau *Cazuri*, în **Acțiuni rapide** (*Raport caz*) și în pagina **Rapoarte**.',
        caseCard: 'Card de caz',
        hint: 'După salvare, sesiunea curentă devine punct plin pe bară.',
      },
      notes: {
        title: 'Jurnalul sesiunii',
        body:
          'Notele sunt pentru observații sensibile sau personale asupra cazului. Spre deosebire de raport, nota nu închide sesiunea. \n\nLe găsești ca **+ Notă** pe cardul de caz din *Dashboard* sau *Cazuri*, în **Acțiuni rapide** (*Adaugă Notă*) și în pagina **Jurnalul sesiunii**, unde poți comuta între *Notă* și *Tablou* pentru fiecare sesiune.',
        example: 'A cerut să reluăm discuția despre iertare săptămâna viitoare.',
      },
      tablou: {
        title: 'Tabloul întâlnirii',
        body:
          'Tabloul e o reflecție mai amplă asupra sesiunii, pe patru straturi — nu doar ce s-a întâmplat, ci și ce pare să creadă persoana și ce îi conduce inima. Nu intră niciodată în raportul către lider — e doar pentru tine și mentorul tău.\n\nÎl deschizi cu **+ Tablou** din *Jurnalul sesiunii*, din bara de sesiuni cu butonul **Vezi tabloul** (dacă sesiunea are deja unul), sau direct după ce închei o sesiune.',
        layers: 'Cele patru straturi',
      },
      aprofundeaza: {
        title: 'Aprofundează',
        body:
          'Butonul **Aprofundează** deschide aceeași pregătire de sesiune ca pe *Dashboard*, direct din *Cazuri* — fără să fie nevoie de o programare.\n\nVezi subiectul ultimei sesiuni, tabloul ei (sau raportul, dacă sesiunea nu are încă un tablou) și tema practică. Din bara de sesiuni a ferestrei poți alege și o sesiune mai veche.\n\nPe telefon, pe cardul de caz apare doar ca iconiță — o carte deschisă lângă numele cazului, fără textul „Aprofundează". Pe ecran mai lat, apare ca buton cu text, în rândul de acțiuni.',
        caseCard: 'Card de caz',
        mobileOnly: 'Doar pe telefon',
        preview: 'Pregătește sesiunea',
        subject: 'Subiectul ultimei sesiuni',
        tabloulOrReport: 'Tabloul sesiunii (sau raportul, dacă nu există tablou)',
        practicalTask: 'Tema practică dată',
      },
      road: {
        title: 'Bara de sesiuni',
        body:
          'Bara de sesiuni este o vizualizare sumară a sesiunilor unui caz. Ea apare pe **cardul de caz** din *Dashboard* sau *Cazuri*. \n\nPunctele numerotate de pe fiecare caz arată unde ai ajuns. Aspectul punctului îți spune starea sesiunii.',
        done: 'Încheiată',
        doneDetail:
          'Are raport adăugat. Apasă punctul ca să-l recitești — sau alege Vezi tabloul, dacă sesiunea are unul.',
        next: 'Următoarea',
        nextDetail: 'Adaugi raport, programezi sau pregătești întâlnirea.',
        future: 'Viitoare',
        futureDetail: 'Este un slot liber în care poți programa o sesiune.',
      },
      calendar: {
        title: 'Calendarul',
        body:
          'Calendarul e în meniul din stânga. Deschizi o zi și apeși **Programează** — întâlnirea se leagă de caz și apare pe bara de sesiuni.\n\nPoți programa și din **Acțiuni rapide** (*Programare nouă*) sau cu **Programează** pe cardul de caz din *Dashboard* sau *Cazuri*.',
        chooseDay: 'Alege o zi',
        dayPanel: 'Panoul zilei',
      },
      resources: {
        title: 'Resursele',
        body:
          'Materialele sunt organizate în foldere. Deschizi un folder și alegi un link ca să consulți resursa.\n\nLe găsești în meniul din stânga, la **Resurse**, și pe *Dashboard* în widget-ul **Resurse utile**.',
        folder: 'Consiliere pastorală',
        firstMeeting: 'Ghid pentru prima întâlnire',
        consent: 'Formular de consimțământ',
        family: 'Materiale pentru familie',
      },
    },
  },

  pwa: {
    installTitle: 'Instalează Consiliere360',
    installButton: 'Instalează',
    installAndroidHint: 'Adaugă Consiliere pe ecranul principal sau în dock, ca o aplicație.',
    installIosStep1: 'Apasă butonul de partajare din bara Safari',
    installIosStep2: 'Derulează și alege „Add to Home Screen”',
    installIosOtherBrowser:
      'Deschide adresa în Safari ca să poți instala aplicația. Celelalte browsere de pe iPhone creează doar o scurtătură, fără notificări.',
    badgeTitle: 'Activează notificările',
    badgeHint:
      'Permite notificările ca să primești alertele chiar și când aplicația e închisă.',
    badgeRegisterFailed:
      'Notificările nu s-au putut activa pe acest dispozitiv. Încearcă din nou mai târziu.',
    badgeButton: 'Permite',
    badgeBlocked:
      'Notificările sunt blocate. Activează-le din setările telefonului pentru această aplicație.',
    badgeNeedsInstall:
      'Pentru a primi notificări pe icoană: Share → Add to Home Screen, apoi deschide aplicația de acolo.',
    badgeUnsupported: 'Notificările nu sunt disponibile pe acest dispozitiv sau în acest browser.',
  },

  // Login
  login: {
    title: 'Biserica Lumina',
    subtitle: 'Sistem de Management Consiliere',
    emailLabel: 'Adresă Email',
    passwordLabel: 'Parolă',
    showPassword: 'Afișează parola',
    hidePassword: 'Ascunde parola',
    signInButton: 'Autentificare',
    credentialsError: 'Conectare eșuată. Verifică credențialele.',
    fillFieldsError: 'Completează toate câmpurile',
    contactAdmin: '*Contactează administratorul pentru credențiale'
  },

  // Notifications (topbar bell)
  notifications: {
    title: 'Notificări',
    subtitle: 'Ce necesită atenția ta',
    empty: 'Nu ai notificări noi',
    dismiss: 'Ascunde',
    typeEvent: 'Eveniment',
    typeAssignment: 'Alocare',
    typeAppointment: 'Programare',
    typeStaleReport: 'Raport',
    typeFrequencyOverdue: 'Frecvență',
    eventDetail: 'Eveniment nou pe care nu l-ai văzut încă',
    assignmentProposedTitle: 'Caz propus pentru tine',
    assignmentAssignedTitle: 'Caz nou alocat',
    assignmentDetail: 'Caz: {title}',
    assignmentDetailFallback: 'Ai o alocare care așteaptă răspunsul tău',
    proposalAcceptedTitle: 'Propunere acceptată',
    proposalRejectedTitle: 'Propunere refuzată',
    proposalAcceptedDetail: '{name} a acceptat cazul „{title}”',
    proposalRejectedDetail: '{name} a refuzat cazul „{title}”',
    typeProposalOutcome: 'Răspuns',
    typeProposalDeclined: 'Acțiune',
    appointmentTitle: 'Programare în curând',
    appointmentDetail: '{case} · {time}',
    staleReportTitle: 'Raport de sesiune lipsă',
    staleReportDetail: 'Cazul „{name}” nu are raport de peste 30 de zile',
    frequencyOverdueTitle: 'Frecvență întâlniri depășită',
    frequencyOverdueDetail:
      'Cazul „{name}” · {frequency} — depășită cu {overdue}',
    typeMonthlyReport: 'Raport lunar',
    monthlyReportDueTitle: 'Completează raportul lunar',
    monthlyReportDueDetail: 'Te rugăm să completezi raportul pentru {month}',
    monthlyReportOverdueTitle: 'Raportul lunar este restant',
    monthlyReportOverdueDetail: 'Raportul pentru {month} nu a fost trimis. Completează-l acum.',
    typeSessionReportSubmitted: 'Raport sesiune',
    sessionReportSubmittedTitle: 'Raport de sesiune trimis',
    sessionReportSubmittedDetail: '{name} a adăugat un raport pentru „{case}”',
    typeMonthlyReportSubmitted: 'Raport lunar',
    monthlyReportSubmittedTitle: 'Raport lunar trimis',
    monthlyReportSubmittedDetail: '{name} a trimis raportul pentru {month}',
    typeConsentUploaded: 'Consimțământ',
    consentUploadedTitle: 'Consimțământ încărcat',
    consentUploadedDetail: '{name} a atașat consimțământul pentru „{case}”',
  },

  // Dashboard
  dashboard: {
    title: 'Panou de Control',
    welcome: 'Bun venit',
    yourPerformance: 'Status cazuri',
    totalCases: 'Cazuri Totale',
    activeCases: 'Active',
    pendingCases: 'În Așteptare',
    completedCases: 'Finalizate',
    upcomingAppointments: 'Programări Următoare',
    today: 'Astăzi',
    yesterday: 'Ieri',
    daysAgo: 'zile în urmă',
    newCaseAssigned: 'Caz Nou Alocat',
    newCaseAssignedMessage: 'Un caz nou ți-a fost alocat. Te rugăm să revizuiești detaliile cazului și să acționezi conform necesității.',
    newCaseProposed: 'Propunere de caz',
    newCaseProposedMessage: 'Ți s-a propus un caz. Poți accepta sau refuza propunerea.',
    acceptProposal: 'Acceptă',
    refuseProposal: 'Refuză',
    seeCase: 'Vezi Cazul',
    noAppointments: 'Nu există programări viitoare',
    upcoming: 'Următoare',
    viewFullProfile: 'Vezi Profil Complet',
    quickActions: 'Acțiuni Rapide',
    viewAllCases: 'Vezi Toate Cazurile',
    scheduleAppointment: 'Programează Întâlnirea',
    updateProfile: 'Actualizează Profil',
    goToCalendar: 'Mergi la Calendar',
    recentActiveCases: 'Cazuri active recente',
    viewAllActiveCases: 'Vezi toate cazurile active',
    raportLunar: 'Raport lunar',
    raportCaz: 'Raport caz',
    comingSoon: 'În curând',
    quickPanel: 'Panou rapid',
    alerts: 'Atenție',
    progress: 'Progres',
    todayFocus: {
      greeting: 'Bună, {name}',
      nextAction: 'Următoarea acțiune',
      alsoNeedsAttention: 'Necesită atenția ta',
      allClearTitle: 'Totul este la zi',
      allClearBody: 'Nu ai rapoarte restante sau sesiuni de pregătit în următoarele 48 de ore.',
      prepareTitle: 'Pregătește sesiunea #{n}',
      reportTitle: 'Închide sesiunea',
      frequencyTitle: 'Frecvență depășită',
      consentTitle: 'Consimțământ lipsă',
      prepareCta: 'Pregătește sesiunea',
      reportCta: 'Închide sesiunea',
      scheduleCta: 'Programează',
      consentCta: 'Încarcă',
      monthlyReportDueTitle: 'Raport lunar de completat',
      monthlyReportOverdueTitle: 'Raport lunar restant',
      monthlyReportCta: 'Completează raportul',
      openMemento: 'Deschide memento',
      openTablou: 'Deschide tabloul',
      myAppointments: 'Programările următoare',
    },
    prepareSession: {
      title: 'Pregătește sesiunea #{n}',
      initialProblem: 'Problema inițială',
      counselingTrail: 'Fir & pasaje',
      lastSession: 'Ultima sesiune',
      sessionHeading: 'Sesiunea #{n}',
      tabloulMissing: 'Tabloul sesiunii {n} nu e completat.',
      tabloulFill: 'Completează',
      tabloulSkip: 'Sari peste',
      tabloulAdd: '+ Adaugă tablou',
      openStep: 'Tema practică',
      openStepToVerify: 'de verificat la întâlnire',
      openStepPassage: 'Pasaj',
      openStepType: 'Tip',
      history: 'Ultima notă',
      noDescription: 'Nu există descriere pentru acest caz.',
      noLastSession: 'Nu există încă un raport de sesiune.',
      noHistory: 'Nicio notă privată pentru acest caz',
      noAppointment: 'Fără programare setată',
      loadError: 'Nu am putut încărca contextul sesiunii.',
    },
    sessionRoadCaption: '{count} {reports} · următoarea: sesiunea {next}',
    sessionRoadNodeDone: 'finalizată',
    sessionRoadNodeNext: 'următoarea',
    sessionRoadNodeOpen: 'planificată',
    sessionRoadHiddenDone: '{n} sesiuni anterioare',
    sessionRoadDoneTooltip: 'Sesiune finalizată. Raport adăugat.',
    sessionRoadDoneTooltipShort: 'Sesiune finalizată.',
    sessionRoadNextTitle: 'Sesiunea {n} · următoarea',
    sessionRoadFutureTitle: 'Sesiunea {n} · viitoare',
    sessionRoadUnscheduled: 'Neprogramată',
    sessionRoadNoAppointment: 'Nicio întâlnire programată',
    sessionRoadScheduledFor: 'Programată {when}',
    sessionRoadScheduleCta: 'Programează întâlnire',
    sessionRoadPrepareCta: 'Pregătește sesiunea',
    sessionRoadOpenReport: 'Vezi raportul',
    sessionRoadViewTablou: 'Vezi tabloul',
    viewCase: 'Vezi',
    notes: 'Note',
    schedule: 'Programează',
    viewAllActivity: 'Vezi toată activitatea',
    controlPanelSubtitle: 'Panou de control – Departamentul de Consiliere',
    weeklyVerse: 'Versetul săptămânii',
    resourcesWidget: {
      title: 'Resurse utile',
      body: 'Materiale și instrumente pentru o consiliere eficientă.',
      cta: 'Vezi resurse',
    },
    searchPlaceholder: 'Caută cazuri, persoane...',
    caseSelectionCountSingular: '1 caz disponibil',
    caseSelectionCountPlural: '{n} cazuri disponibile',
    caseSelectionSearch: 'Caută după persoană sau caz...',
    caseSelectionNoMatch: 'Niciun caz nu corespunde căutării'
  },

  // Delete/Deactivate Warnings
  deleteWarnings: {
    deleteCase: 'Șterge Caz',
    deleteCaseConfirm: 'Ești sigur că vrei să ștergi cazul "{title}"? Această acțiune nu poate fi anulată.',
    deleteCounselor: 'Șterge Consilier',
    deleteCounselorConfirm: 'Ești sigur că vrei să ștergi consilierul "{name}"? Această acțiune nu poate fi anulată.',
    deleteCounselorWarning: 'Acest consilier are {count} cazuri alocate. Te rog realocă aceste cazuri înainte de ștergere.',
    deleteAppointment: 'Șterge Programare',
    deleteAppointmentConfirm: 'Ești sigur că vrei să ștergi programarea "{title}"? Această acțiune nu poate fi anulată.',
    thisActionCannotBeUndone: 'Această acțiune nu poate fi anulată'
  },

  // Cases
  cases: {
    title: 'Cazuri',
    subtitle: 'Cazurile tale alocate',
    searchLabel: 'Căutare',
    filterByStatus: 'Filtrează după status',
    singleCaseView: 'Vizualizare caz singular',
    clientInfo: 'Informații Consiliat',
    createCase: 'Creează Caz',
    editCase: 'Editează Caz',
    editFormSubtitle: 'Actualizează statusul, tipul problemei și descrierea',
    editDescription: 'Editează descrierea',
    editDescriptionSubtitle: 'Actualizează descrierea cazului',
    createFormSubtitle: 'Completează detaliile cazului nou',
    sectionAssignment: 'Alocare',
    deleteCase: 'Șterge Caz',
    caseDetails: 'Detalii Caz',
    caseTitle: 'Titlu caz',
    caseTitlePlaceholder: 'Ex. Anxietate, conflict în familie',
    caseTitleRequired: 'Titlul cazului este obligatoriu',
    requiredMissing: 'Completează: {fields}',
    counseledName: 'Nume Persoană Consiliată',
    lastName: 'Nume',
    firstName: 'Prenume',
    age: 'Vârstă',
    years: 'ani',
    sex: 'Sex',
    sexMasculin: 'M',
    sexFeminin: 'F',
    sexMasculinAdult: 'M',
    sexFemininAdult: 'F',
    sexMasculinMinor: 'M',
    sexFemininMinor: 'F',
    civilStatus: 'Stare Civilă',
    civilStatusTitle: 'Stare Civilă',
    phoneNumber: 'Număr Telefon',
    description: 'Descriere',
    problemDescription: 'Descriere Problemă',
    status: 'Status',
    issueTypes: 'Tipuri de Problema',
    issueTypesTitle: 'Tipuri de Problemă',
    referralSource: 'Sursă trimitere',
    referralSourceOptional: 'Sursă trimitere (opțional)',
    priority: 'Prioritate',
    assignedCounselor: 'Consilier Alocat',
    assignedCounselorTitle: 'Consilier Alocat',
    assignedCounselorChip: 'Consilier alocat: {name}',
    proposalBadge: 'Propunere: {name}',
    unassignedBadge: 'Nealocat',
    reassign: 'Reasignează',
    reassignTitle: 'Reasignează cazul',
    reassignSubtitle: 'Alege un consilier. Poți propune sau atribui direct.',
    reassignUnassignedHint: 'Cazul a rămas fără consilier. Alege pe cineva pentru a continua.',
    reassignCounselorRequired: 'Selectează un consilier',
    reassignSuccess: 'Consilierul a fost actualizat',
    reassignPropose: 'Propune',
    reassignForce: 'Atribuie',
    priorityBadge: 'Prioritar',
    created: 'Creat',
    createdLabel: 'Creat',
    updated: 'Actualizat',
    viewAllNotes: 'Vezi ultimele note',
    noDescriptionProvided: 'Nu există descriere',
    updateSuccess: 'Caz actualizat cu succes',
    updateError: 'Eroare la actualizarea cazului',
    filters: {
      all: 'Cazuri',
      active: 'Active',
      pending: 'În Așteptare',
      completed: 'Finalizate',
      waiting: 'În Așteptare',
      unfinished: 'Nefinalizate',
      searchPlaceholder: 'Căutați cazuri'
    },
    noCases: 'Nu există cazuri',
    noCasesMessage: 'Nu există cazuri disponibile momentan.',
    viewFullDescription: 'Vezi Descrierea Completă',
    timeline: 'Cronologie',
    actions: 'Acțiuni',
    addConsent: 'Adaugă consimțământ',
    consentAttached: 'Consimțământ atașat',
    consentMissingTitle: 'Consimțământ lipsă',
    consentMissingBody: 'Te rog adaugă consimțământul după prima întâlnire.',
    consentPendingTitle: 'Trimite consimțământul',
    consentPendingBodyBefore: 'Apasă ',
    consentPendingBodyMid: ' pentru a trimite fișierul, sau ',
    consentPendingBodyAfter: ' dacă ai selectat greșit.',
    consentConfirmTitle: 'Confirmă încărcarea consimțământului',
    consentConfirmMessage:
      'Este acesta fișierul/imaginea pe care vrei să o încarci?',
    consentConfirmWarning:
      'Această acțiune poate fi modificată doar de lider — fii atent!',
    consentConfirmAction: 'Continuă',
    consentUploadAction: 'Încarcă',
    consentSelectedFile: 'Fișier selectat',
    consentChangeFile: 'Schimbă fișierul',
    consentUploadSuccess: 'Consimțământul a fost încărcat',
    consentUploadError: 'Eroare la încărcarea consimțământului',
    consentInvalidType: 'Tip fișier neacceptat. Folosește PDF, JPEG sau PNG.',
    consentTooLarge: 'Fișierul depășește 5MB.',
    cockpit: {
      sessionPath: 'Traseu sesiuni',
      lastMeeting: 'Ultima întâlnire',
      noMeetingYet: 'Nicio întâlnire încă',
      lastTheme: 'Ultimul subiect discutat',
      noTheme: 'Fără raport de sesiune',
      nextStep: 'Pasul următor',
      noNextStep: 'Niciun pas deschis',
      nextStepFromSession: 'din sesiunea {n}',
      nextStepPassage: 'Pasaj',
      nextAppointment: 'Următoarea întâlnire',
      noAppointment: 'Fără programare',
      frequencyOverdue: 'Frecvență depășită',
      frequencyOverdueBy: 'Depășit cu {duration}',
      reportMissing: 'Raport de sesiune lipsă',
      reportMissingHint: 'A trecut o întâlnire fără raport',
      clarifyPending: 'Sesiunea {n} neclarificată',
      clarifyPendingHint: 'Ai amânat clarificarea tabloului întâlnirii',
      scheduleCta: 'Programează',
      showDetails: 'Detalii caz',
      hideDetails: 'Ascunde detaliile',
      counseledPerson: 'Persoana consiliată',
      aboutCase: 'Despre caz',
      consentLabel: 'Consimțământ',
      consentNotAttached: 'Neatașat',
      consentAttachedOn: 'Atașat la {date}',
      consentAttachedNoDate: 'Atașat',
      addReportCta: '+ Raport',
      addNoteCta: '+ Notă',
      addTabloulCta: '+ Tablou',
      viewReportsCta: 'Rapoarte',
      deepenCta: 'Aprofundează',
    },
  },

  caseTimeline: {
    title: 'Cronologie caz',
    loadError: 'Eroare la încărcarea cronologiei',
    empty: 'Nu există încă evenimente pe acest caz.',
    openedTitle: 'Caz deschis',
    noteTitle: 'Notă de sesiune',
    reportTitle: 'Raport sesiune nr. {n}',
    appointmentTitle: 'Programare',
    statusTitle: 'Schimbare status',
    openNotes: 'Deschide notele',
    openReports: 'Vezi rapoartele',
    openCalendar: 'Vezi calendarul',
    byAuthor: 'De',
  },

  referralSources: {
    none: 'Nespecificat',
    pastor: 'Pastor',
    self: 'Din proprie inițiativă',
    friend: 'Prieten / familie',
    other: 'Altele',
  },

  casePriority: {
    normal: 'Normală',
    high: 'Ridicată',
  },

  // Assignment / intake
  assignments: {
    matchLabel: 'potrivire',
    sexMatchLabel: 'același sex',
    recommendedLabel: 'Recomandat',
    forceAssign: 'Atribuie direct (fără acceptare)',
    forceAssignHint: 'Cazul devine activ imediat, fără ca consilierul să accepte.',
    specialtyCategory: 'Categorie',
    specialtyCategoryRequired: 'Selectează categoria specialității',
    acceptSuccess: 'Ai acceptat cazul',
    refuseSuccess: 'Ai refuzat propunerea',
    acceptError: 'Eroare la acceptarea propunerii',
    refuseError: 'Eroare la refuzarea propunerii',
    caseMissingTitle: 'Cazul nu mai există',
    caseMissingDetail:
      'Acest caz a fost șters. Poți curăța notificarea — nu mai este nevoie să accepți sau să refuzi.',
    clearStaleNotification: 'Curăță notificarea',
  },

  // Admin Tools
  adminTools: {
    title: 'Unelte Admin',
    userManagement: 'Gestionare Utilizatori',
    counselorsManagement: 'Gestionare Consilieri',
    allCasesManagement: 'Gestionează cazuri',
    addUser: 'Adaugă Utilizator',
    addCounselor: 'Creează Profil',
    addCase: 'Adaugă Caz',
    searchCounselors: 'Caută consilieri...',
    searchCases: 'Caută cazuri...',
    allCounselors: 'Toți Consilierii',
    allStatuses: 'Toate',
    noCounselorsFound: 'Nu există consilieri.',
    noCasesFound: 'Nu există cazuri.',
    noMatchFound: 'Nu se potrivește nimic cu criteriile de căutare.',
    workload: 'Sarcină de Lucru',
    specialty: 'Specialitate',
    cases: 'Cazuri',
    linkUserAccount: 'Leagă la Cont Utilizator *',
    manageReports: 'Vezi Rapoartele',
    openReports: 'Deschide Rapoarte',
    sensitiveContentRestricted:
      'Conținut confidențial — vizibil doar pentru lideri.',
  },

  caseClosure: {
    title: 'Raport de încheiere',
    reportTypeTitle: 'Ce tip de raport dorești să adaugi?',
    reportTypeSubtitle: 'Alege fluxul potrivit pentru această sesiune.',
    normalReport: 'Raport de sesiune',
    normalReportDescription: 'Continuă cazul și înregistrează progresul sesiunii.',
    finalReport: 'Raport final',
    finalReportDescription: 'Completează evaluarea finală și încheie cazul.',
    closeCase: 'Încheie cazul',
    sectionOutcome: 'Încheiere',
    sectionEvaluation: 'Evaluare finală',
    status: 'Rezultatul cazului',
    outcome: {
      finished: 'Finalizat',
      unfinished: 'Nefinalizat',
      cancelled: 'Anulat',
    },
    lastSession: 'Ultima sesiune (opțional)',
    noSession: 'Fără sesiune asociată',
    unfinishedReason: 'Care este motivul pentru care cazul nu a fost finalizat?',
    nextSteps: 'Ce se întâmplă în continuare cu persoana / cazul?',
    cancellationReason: 'Care este motivul anulării cazului?',
    unfinishedRequired: 'Completează motivul nefinalizării și pașii următori',
    cancellationRequired: 'Completează motivul anulării',
    problemUnderstanding:
      'Care a fost problema principală pentru care persoana a venit la consiliere și cum o înțelegem acum, la finalul procesului?',
    observedChanges:
      'Ce schimbări concrete ai observat în viața persoanei pe parcursul procesului de consiliere?',
    gospelRelationship:
      'Cum s-a schimbat relația persoanei cu Dumnezeu și modul în care aplică Evanghelia în domeniul abordat?',
    finalEvaluation: 'Care este evaluarea ta finală asupra cazului?',
    evaluation: {
      continue_alone: 'Poate continua singur',
      needs_follow_up: 'Are nevoie de follow-up',
      continue_counseling: 'Este recomandată continuarea consilierii',
      other_responsible: 'Este necesară implicarea altui responsabil',
    },
    evaluationDetails: 'Detalii pentru evaluarea finală',
    evaluationDetailsHint: {
      needs_follow_up: 'Ce follow-up este necesar și cine îl preia?',
      continue_counseling: 'De ce este recomandată continuarea consilierii?',
      other_responsible: 'Cine ar trebui implicat și de ce?',
    },
    closedOn: 'Încheiat la',
    closedBy: 'Încheiat de',
    requiredFields: 'Completează cele trei întrebări și evaluarea finală',
    evaluationRequired: 'Selectează evaluarea finală a cazului',
    followUpRequired: 'Completează detaliile pentru follow-up',
    useCloseAction: 'Folosește acțiunea „Încheie cazul” pentru acest status',
    saveSuccess: 'Cazul a fost încheiat și raportul a fost salvat',
    saveError: 'Raportul de încheiere nu a putut fi salvat',
  },

  /**
   * Passive prompt for the counselor during a session — the question types from Modul II
   * ("Sugestii pentru a putea pune întrebări ajutătoare") and the trap that module opens with. Nothing here
   * is stored or answered; it exists to be glanced at.
   */
  sessionClosed: {
    title: 'Raportul a fost trimis',
    prompt: 'Ai 10 minute acum?',
    body:
      'Clarifică tabloul întâlnirii cât e proaspătă — situația, răspunsurile, gândurile, motivele.',
    now: 'Clarific acum',
    later: 'Mai târziu',
  },

  tablou: {
    title: 'Tabloul întâlnirii',
    badge: 'Tablou',
    bannerBold: 'Nu intră în raportul către lider.',
    bannerTail: 'Toate câmpurile sunt opționale.',
    situatiaTitle: 'Situația',
    situatiaLabel:
      'Ce situații sau evenimente au apărut în discuție?',
    situatiaHint: 'Fără interpretarea ta încă — doar ce a povestit.',
    raspunsurileTitle: 'Răspunsurile',
    raspunsurileLabel:
      'Cum a răspuns la ceea ce trăiește? ',
    raspunsurileHint: 'Ce observ în gândurile, emoțiile, cuvintele, deciziile și acțiunile ei? Ce se repetă sau se schimbă?',
    gandurileTitle: 'Credințele',
    gandurileLabel:
      'Ce pare să creadă persoana despre ceea ce trăiește?',
    gandurileHint: 'Nu adevărul teologic, ci ceea ce pare să creadă inima despre sine, ceilalți, situație sau Dumnezeu.',
    motiveleTitle: 'Motivele',
    motiveleLabel:
      'Ce pare să conducă inima?',
    motiveleHint:
      'Ce pare să dorească, să protejeze sau să obțină? Unde își caută siguranța, valoarea, controlul sau acceptarea?',
    save: 'Salvează tabloul',
    saveError: 'Nu am putut salva tabloul. Încearcă din nou.',
    loadError: 'Nu am putut încărca tabloul acestei sesiuni. Închide și încearcă din nou.',
  },

  sessionQuestions: {
    title: 'Întrebări ajutătoare',
    show: 'Vezi întrebările',
    hide: 'Ascunde',
    what: 'Ce?',
    whatHint: 'Cere-i să definească. Nu presupune ce înseamnă „ne-am certat”.',
    how: 'Cum?',
    howHint: 'Un exemplu concret, derulat pas cu pas.',
    why: 'De ce?',
    whyHint: 'Motivele, scopurile, ce urmărește de fapt.',
    whereOften: 'Cât de des? Unde?',
    whereOftenHint: 'Aici ies tiparele la suprafață.',
    when: 'Când?',
    whenHint: 'Ordinea faptelor, cronologia.',
    checkTitle: 'Verificarea mea',
    presupus: 'Ce am presupus fără să verific?',
    intrebareLipsa: 'Ce întrebare nu am pus și ar fi trebuit?',
    noteTitle: 'Notă rapidă',
    notePlaceholder: 'Ce vreau să rețin din ce s-a spus…',
    noteCaseLabel: 'Cazul',
    noteSave: 'Salvează nota',
    noteSaved: 'Notă salvată',
    noteError: 'Nu am putut salva nota. Încearcă din nou.',
    noCases: 'Nu ai cazuri active.',
  },

  // Appointments
  appointments: {
    historyLimit:
      'Calendarul afișează ultimele 3 luni. Istoricul mai vechi al unui caz se vede pe fișa cazului.',
    title: 'Programări',
    subtitle: 'Programările tale și ale echipei',
    searchLabel: 'Căutare',
    scheduleAppointment: 'Programează Întâlnirea',
    formSubtitle: 'Completează detaliile întâlnirii',
    sectionDetails: 'Detalii',
    sectionSchedule: 'Data și ora',
    sectionLocation: 'Locație',
    editAppointment: 'Editează Programare',
    deleteAppointment: 'Șterge Programare',
    schedule: 'Programează',
    date: 'Data',
    startTime: 'Ora Start',
    endTime: 'Ora Final',
    duration: 'Durată',
    session: 'Sesiune',
    noSession: 'Fără sesiune',
    nextSession: 'următoarea',
    sessionOptionalHint: 'Opțional · implicit este selectată următoarea sesiune',
    room: 'Sala',
    client: 'Client',
    counselor: 'Consilier',
    description: 'Descriere',
    status: 'Status',
    calendarView: 'Vizualizare Calendar',
    listView: 'Vizualizare Listă',
    searchPlaceholder: 'Căutați programări',
    filters: {
      all: 'Programări',
      upcoming: 'Următoare',
      past: 'Trecute',
      today: 'Astăzi',
      week: 'Săptămâna Aceasta',
      month: 'Luna Aceasta',
      allCounselors: 'Toți Consilierii'
    },
    noAppointments: 'Nu există programări',
    noAppointmentsMessage: 'Nu există programări disponibile momentan.',
    deleteSuccess: 'Programare ștearsă cu succes',
    deleteError: 'Eroare la ștergerea programării',
    saveError: 'Eroare la salvarea programării',
    noAppointmentsDay: 'Nu există programări pentru această zi',
    dayScheduleLabel: 'Program',
    moreOnDay: 'în plus',
    pastDateError: 'Nu poți programa în trecut',
    caseRequired: 'Selectează un caz',
    roomRequired: 'Selectează o sală',
    selectCase: 'Selectează cazul',
    selectCounselorForCases: 'Selectează un consilier pentru a vedea cazurile alocate',
    counselorCasesOnly: 'Sunt afișate doar cazurile consilierului selectat',
    selectRoom: 'Selectează sala',
    roomOutsideChurch: 'În afara Bisericii',
    roomConflict: 'Sala este deja rezervată în intervalul selectat',
    roomLegend: 'Săli',
    pastStartTimeError: 'Ora de start trebuie să fie în viitor',
    pastEndTimeError: 'Ora de final trebuie să fie în viitor',
    pastCannotModify: 'Programările din trecut nu pot fi editate sau șterse',
  },

  // Church events (Evenimente)
  events: {
    title: 'Evenimente',
    singular: 'Eveniment',
    addEvent: 'Adaugă Eveniment',
    formSubtitle: 'Completează detaliile evenimentului',
    sectionDetails: 'Detalii',
    sectionSchedule: 'Data și ora',
    sectionRegistration: 'Înscriere',
    editEvent: 'Editează Eveniment',
    deleteEvent: 'Șterge Eveniment',
    deleteConfirm: 'Sigur doriți să ștergeți evenimentul „{name}"?',
    name: 'Nume eveniment',
    description: 'Descriere',
    startDate: 'Data start',
    endDate: 'Data sfârșit',
    startTime: 'Ora start',
    endTime: 'Ora sfârșit',
    registrationUrl: 'Link înscriere',
    registrationUrlHint: 'Opțional — link către formularul de înscriere',
    registrationLink: 'Înscrie-te aici',
    registrationMandatory: 'Înscrierea la acest eveniment este obligatorie.',
    save: 'Salvează',
    nameRequired: 'Numele evenimentului este obligatoriu',
    descriptionRequired: 'Descrierea este obligatorie',
    startDateRequired: 'Data de start este obligatorie',
    endDateRequired: 'Data de sfârșit este obligatorie',
    endDateBeforeStart: 'Data de sfârșit nu poate fi înainte de data de start',
    startTimeRequired: 'Ora de start este obligatorie',
    endTimeRequired: 'Ora de sfârșit este obligatorie',
    minDuration: 'Evenimentul trebuie să dureze cel puțin 15 minute',
    pastDateError: 'Nu poți crea evenimente în trecut',
    pastCannotModify: 'Evenimentele din trecut nu pot fi editate sau șterse',
    invalidUrl: 'Introduceți un URL valid (ex. biserica-lumina.ro)',
    legend: 'Evenimente',
    noEventsDay: 'Nu există evenimente pentru această zi',
    noUnread: 'Nu există evenimente noi',
    notificationsTitle: 'Evenimente noi',
    notificationsSubtitle: 'Evenimente pe care nu le-ai văzut încă',
    createSuccess: 'Eveniment creat cu succes',
    updateSuccess: 'Eveniment actualizat cu succes',
    deleteSuccess: 'Eveniment șters cu succes',
    saveError: 'Eroare la salvarea evenimentului',
    deleteError: 'Eroare la ștergerea evenimentului',
  },

  // Counselors
  counselors: {
    title: 'Consilieri',
    pageTitle: 'Echipa',
    subtitle: 'Gestionează consilierii și sarcina de lucru',
    searchLabel: 'Căutare',
    searchPlaceholder: 'Caută consilieri...',
    workloadLabel: 'Sarcină de lucru',
    allLevels: 'Toate nivelurile',
    countSingular: 'consilier',
    countPlural: 'consilieri',
    noCounselorsFound: 'Nu există consilieri',
    adjustFilters: 'Încearcă să ajustezi filtrele',
    addFirstCounselor: 'Adaugă primul consilier pentru a începe',
    loadError: 'Eroare la încărcarea consilierilor',
    saveError: 'Eroare la salvarea consilierului',
    deleteError: 'Eroare la ștergerea consilierului',
    addCounselor: 'Adaugă consilier',
    editCounselor: 'Editează Consilier',
    deleteCounselor: 'Șterge Consilier',
    fullName: 'Nume Complet',
    email: 'Email',
    phoneNumber: 'Număr Telefon',
    specialties: 'Specializări',
    specialtiesTitle: 'Specializări',
    workload: 'Sarcină',
    workloadLevel: {
      low: 'Scăzut',
      moderate: 'Moderat',
      high: 'Ridicat'
    },
    activeCases: 'Cazuri Active',
    activeCasesTitle: 'Cazuri Active',
    waitingCases: 'Cazuri în Așteptare',
    caseSummary: 'Rezumat Cazuri',
    recentCases: 'Cazuri Recente',
    seeHistory: 'Vezi Istoric',
    caseHistory: 'Istoric Cazuri',
    totalCases: 'Cazuri Totale',
    historyEmptyFilter: 'Niciun caz pentru acest filtru',
    filters: {
      all: 'Toți',
      low: 'Sarcină Scăzută',
      moderate: 'Sarcină Moderată',
      high: 'Sarcină Ridicată'
    },
    noCounselors: 'Nu există consilieri',
    noCounselorsMessage: 'Nu există consilieri disponibili momentan.'
  },

  // Session Reports
  sessionReports: {
    title: 'Rapoarte Post-Sesiune',
    subtitle: 'Istoricul sesiunilor de consiliere, grupat pe caz',
    addReport: '+ Raport',
    searchPlaceholder: 'Caută după caz, persoană sau subiect...',
    counselorLabel: 'Consilier',
    periodLabel: 'Perioadă',
    statusLabel: 'Status caz',
    statusActive: 'Active',
    statusOthers: 'Altele',
    allCounselors: 'Toți consilierii',
    allStatuses: 'Toate statusurile',
    casesWithReports: 'Cazuri cu rapoarte',
    casesList: 'Cazuri',
    caseSingular: 'caz găsit',
    casePlural: 'cazuri găsite',
    reportSingular: 'raport',
    reportPlural: 'rapoarte',
    lastReport: 'Ultimul',
    noReportsYet: 'Fără raport',
    sessions: 'Sesiuni',
    sessionNumber: 'Sesiunea',
    theme: 'Subiect',
    counselingTrail: {
      theme: 'Fir',
      passages: 'Pasaje',
    },
    selectCase: 'Selectează un caz din listă pentru a vedea sesiunile.',
    noReportsForCase: 'Nu există rapoarte pentru acest caz.',
    addFirstReportHint: 'Niciun raport încă — adaugă primul pentru acest caz.',
    noCases: 'Nu există cazuri pentru filtrele selectate.',
    loadError: 'Eroare la încărcarea rapoartelor',
    selectCaseForReport: 'Selectează caz pentru raport',
    selectCaseForNote: 'Selectează caz pentru notă',
    selectCaseForConsent: 'Selectează caz pentru consimțământ',
    noActiveCases: 'Nu există cazuri active disponibile pentru raportare',
    noActiveCasesForNote: 'Nu există cazuri active disponibile pentru note',
    noActiveCasesForConsent:
      'Nu există cazuri active fără consimțământ',
    reportDetails: 'Detalii raport',
    meetingDate: 'Data întâlnirii',
    meetingDateRequired: 'Data întâlnirii este obligatorie',
    meetingDateFuture: 'Data întâlnirii nu poate fi în viitor',
    meetingFrequency: 'Frecvența întâlnirilor',
    meetingFrequencyRequired: 'Selectează frecvența întâlnirilor',
    meetingFrequencyOptionalHint: 'Poți actualiza frecvența dacă s-a schimbat',
    frequencyOptions: {
      1: 'Săptămânal',
      2: 'La 2 săptămâni',
      3: 'La 3 săptămâni',
      4: 'Lunar',
    },
    fields: {
      mainTheme: '1. Subiectul principal abordat',
      personResponse: '2. Răspuns la subiect',
      previousTask: '3. Tema practică anterioară',
      progress: '4. Progres observat',
      commitments: '5. Tema practică pentru următoarea întâlnire',
      reason: 'Motiv',
    },
    wizard: {
      title: 'Adaugă raport',
      stepContext: 'Context',
      stepResponseProgress: 'Subiect și răspuns',
      stepTheme: 'Pași',
      stepProgress: 'Progres',
      stepLabel: 'Pasul {n}',
      forward: 'Înainte',
      saveReport: 'Salvează raport',
      sessionNumber: 'Numărul sesiunii',
      frequencyPlaceholder: 'Selectează frecvența',
      mainTheme: 'Care a fost subiectul principal abordat?',
      mainThemeHint: 'Subiectul sesiunii de azi — ex: iertare, relații, frică, identitate.',
      mainThemePlaceholder: 'Introdu subiectul principal...',
      personResponse: 'Cum a răspuns persoana la subiect?',
      personResponseHint:
        'ex: a recunoscut problema, a pus întrebări, a rezistat, a înțeles treptat, a făcut o decizie etc.',
      personResponsePlaceholder: 'Descrie cum a răspuns la subiectul discutat...',
      previousTask: 'Tema practică anterioară împlinită?',
      previousTaskHint:
        'Verifică tema practică lăsată la sesiunea anterioară — da, parțial sau nu.',
      previousTaskReasonPlaceholder:
        'ex: Pasajul da; conversația încă nu…',
      previousTaskReasonRequired:
        'Te rugăm să completezi motivul pentru care tema practică nu a fost împlinită',
      previousStepLabel: 'Tema practică anterioară (de verificat)',
      previousStepFallback: 'Nu există un pas structurat salvat — verifică din memorie / note.',
      partial: 'Parțial',
      progress: 'Ai observat progres?',
      progressHint: 'Față de sesiunile anterioare — în înțelegere, atitudine sau acțiune.',
      progressPlaceholderYes: 'Ce s-a schimbat concret?',
      progressPlaceholderPartial: 'Ce s-a mișcat și ce rămâne neschimbat?',
      progressPlaceholderNo: 'Ce blochează progresul?',
      progressDetailsRequired: 'Descrie pe scurt observația despre progres',
      progressPlaceholder: 'Descrie progresul observat...',
      commitments: 'Tema practică pentru următoarea întâlnire?',
      commitmentsHint:
        'Un pas principal. Pașii secundari pot intra la «Ce anume».',
      commitmentsDetailsPlaceholder:
        'ex: Citește zilnic; notează 1 verset; discută cu soția până vineri',
      commitmentsDetailsRequired: 'Descrie ce anume trebuie făcut',
      nextStepType: 'Tip',
      nextStepTypeHint:
        'Categoria principală a angajamentului — restul detaliilor le scrii la «Ce anume».',
      nextStepTypeRequired: 'Alege tipul pasului',
      nextStepPassage: 'Pasaj biblic',
      nextStepPassageHint: 'Recomandat la consiliere biblică',
      nextStepPassagePlaceholder: 'ex: Psalmul 73',
      nextStepDescription: 'Ce anume',
      nextStepDescriptionHint:
        'Poți adăuga pași secundari aici.',
      noCommitmentsReasonPlaceholder: 'De ce nu există angajamente?',
      noCommitmentsReasonRequired: 'Explică de ce nu există angajamente',
      requiredFields: 'Completează toate câmpurile obligatorii',
      nextStepTypes: {
        scripture: 'Studiu',
        prayer: 'Rugăciune',
        practice: 'Aplicare',
        conversation: 'Conversație',
        reconciliation: 'Reconciliere',
        reflection: 'Reflecție',
        other: 'Altul',
      },
    },
    metrics: {
      total: 'Rapoarte totale',
      cases: 'Cazuri cu rapoarte',
      thisMonth: 'Luna aceasta',
    },
  },

  // Time-range filters (session reports)
  activity: {
    periods: {
      threeMonths: 'Ultimele 3 luni',
      sixMonths: 'Ultimele 6 luni',
      nineMonths: 'Ultimele 9 luni',
      allTime: 'Tot timpul',
    },
  },

  // Profile
  profile: {
    title: 'Profilul Meu',
    subtitle: 'Contul și activitatea ta de consiliere',
    personalInfo: 'Informații Personale',
    counselorInfo: 'Informații Consilier',
    fullName: 'Nume Complet',
    lastName: 'Nume',
    firstName: 'Prenume',
    email: 'Email',
    phoneNumber: 'Număr Telefon',
    sex: 'Sex',
    birthDate: 'Data nașterii',
    role: 'Rol',
    specialties: 'Specializări',
    performance: 'Performanță',
    summary: 'Rezumat',
    caseSummary: 'Rezumat Cazuri',
    scheduleSummary: 'Rezumat Programări',
    editProfile: 'Editează Profil',
    formSubtitle: 'Actualizează datele de contact',
    editSpecialties: 'Editează specializări',
    specialtiesFormSubtitle: 'Adaugă sau elimină domeniile tale de expertiză',
    sectionContact: 'Contact',
    noSpecialties: 'Nu există specializări adăugate. Folosește „Editează specializări” pentru a adăuga domeniile tale de expertiză.',
    addSpecialty: 'Adaugă specialitate nouă',
    commonSpecialties: 'Specializări comune (click pentru a adăuga)',
    updateSuccess: 'Profil actualizat cu succes!',
    updateError: 'Eroare la actualizarea profilului',
    loadError: 'Eroare la încărcarea datelor profilului',
    phoneNotProvided: 'Nu este furnizat',
    changeAvatar: 'Schimbă fotografia de profil',
    removeAvatar: 'Elimină fotografia',
    removeAvatarConfirm: 'Sigur doriți să eliminați fotografia de profil?',
    avatarHint: 'Apasă pictograma camerei pentru a adăuga o fotografie de profil.',
    avatarInvalidType: 'Format invalid. Folosește JPG, PNG sau WebP.',
    avatarTooLarge: 'Imaginea este prea mare. Folosește o fotografie sub 5 MB.',
    avatarUpdateSuccess: 'Fotografia de profil a fost actualizată.',
    avatarUpdateError: 'Eroare la actualizarea fotografiei de profil.',
    avatarRemoveSuccess: 'Fotografia de profil a fost eliminată.',
    passwordTitle: 'Parolă',
    passwordSubtitle: 'Schimbă parola contului tău.',
    passwordCurrent: 'Parola actuală',
    passwordNew: 'Parola nouă',
    passwordConfirm: 'Confirmă parola nouă',
    passwordSubmit: 'Schimbă parola',
    passwordMinLength: 'Parola nouă trebuie să aibă cel puțin 8 caractere.',
    passwordMismatch: 'Parolele noi nu coincid.',
    passwordSameAsCurrent: 'Parola nouă trebuie să fie diferită de cea actuală.',
    passwordUpdateSuccess: 'Parola a fost schimbată.',
    passwordUpdateError: 'Nu am putut schimba parola. Încearcă din nou.',
    passwordCurrentWrong: 'Parola actuală este greșită.',
    passwordTooWeak: 'Parola nouă este prea slabă.',
    passwordTooManyAttempts: 'Prea multe încercări. Așteaptă puțin și încearcă din nou.',
    passwordSessionExpired: 'Sesiunea a expirat. Te rugăm să te autentifici din nou.',
    workloadLow: 'Sarcină scăzută',
    workloadModerate: 'Sarcină moderată',
    workloadHigh: 'Sarcină ridicată',
    roleCounselor: 'Consilier',
    roleAdmin: 'Coordonator',
    roleLeader: 'Lider'
  },

  // Admin Tools
  admin: {
    title: 'Unelte Admin',
    subtitle: 'Gestionează utilizatori, consilieri și rolurile lor în sistemul de consiliere.',
    tabs: {
      userManagement: 'Gestionare Utilizatori',
      counselorsManagement: 'Gestionare Consilieri',
      allCases: 'Gestionează cazuri',
      receivedReports: 'Rapoarte lunare',
      manageConsents: 'Gestionează consimțăminte',
      mentorship: 'Mentorat',
    },
    mentorship: {
      title: 'Mentorat',
      subtitle:
        'Pregătește consilieri noi punându-i să asiste, cap-coadă, la cazurile unui consilier experimentat.',
      loadError: 'Eroare la încărcarea relațiilor de mentorat',
      actionError: 'Acțiunea nu a putut fi finalizată',
      mentorsTitle: 'Mentori',
      mentorsEmpty: 'Niciun mentor marcat încă',
      markMentor: 'Marchează mentor',
      markMentorPlaceholder: 'Alege un utilizator…',
      unmarkMentor: 'Nu mai e mentor',
      unmarkBlockedTitle: 'Mentorul are ucenici activi',
      unmarkBlockedBody:
        'Finalizează întâi mentoratul pentru: {{names}}. Așa nimeni nu pierde accesul din greșeală.',
      apprenticesTitle: 'Ucenici',
      apprenticesEmpty: 'Niciun ucenic',
      addApprentice: 'Adaugă ucenic',
      addApprenticePlaceholder: 'Alege un utilizator…',
      noApprenticeCandidates: 'Nu există utilizatori disponibili',
      statusActive: 'În mentorat',
      statusCompleted: 'Mentorat finalizat',
      finish: 'Finalizează mentoratul',
      finishConfirmTitle: 'Finalizează mentoratul',
      finishConfirmBody:
        'Ucenicul păstrează cazurile vizibile și notițele scrise de el, dar nu va mai putea edita nimic. Poți relua mentoratul oricând.',
      reopen: 'Reia mentoratul',
      remove: 'Șterge ucenicul',
      removeConfirmTitle: 'Șterge ucenicul din mentorat',
      removeConfirmBody:
        'Folosește asta doar dacă perechea a fost creată din greșeală. Ucenicul pierde complet accesul la cazurile mentorului. Notițele scrise de el rămân pe caz. Dacă mentoratul s-a încheiat normal, folosește „Finalizează mentoratul".',
      casesTitle: 'Cazuri la care are acces',
      casesEmpty: 'Niciun caz acordat încă',
      manageCases: 'Gestionează cazurile',
      manageCasesTitle: 'Cazuri acordate lui {{name}}',
      manageCasesSubtitle: 'Bifează cazurile mentorului la care ucenicul are acces.',
      mentorHasNoCases: 'Mentorul nu are cazuri alocate momentan',
      strandedWarning:
        'Cazul nu mai este alocat mentorului, dar ucenicul păstrează accesul.',
      save: 'Salvează',
    },
    consents: {
      title: 'Gestionează consimțăminte',
      subtitle: 'Consimțămintele atașate cazurilor',
      empty: 'Nu există consimțăminte încărcate',
      caseLabel: 'Caz',
      personLabel: 'Persoană',
      counselorLabel: 'Consilier',
      uploadedBy: 'Încărcat de',
      uploadedAt: 'Data',
      fileLabel: 'Fișier',
      download: 'Descarcă',
      replace: 'Înlocuiește',
      delete: 'Șterge',
      deleteConfirmTitle: 'Șterge consimțământul',
      deleteConfirmMessage:
        'Ești sigur că vrei să ștergi consimțământul pentru „{name}”? Consilierul va putea încărca din nou unul.',
      replaceConfirmTitle: 'Înlocuiește consimțământul',
      replaceConfirmMessage:
        'Este acesta fișierul/imaginea pe care vrei să o încarci în locul celui existent?',
      loadError: 'Eroare la încărcarea consimțămintelor',
      downloadError: 'Eroare la descărcare',
      deleteSuccess: 'Consimțământul a fost șters',
      replaceSuccess: 'Consimțământul a fost înlocuit',
    },
    users: {
      title: 'Utilizatori',
      addUser: 'Adaugă Utilizator',
      editUser: 'Editează Utilizator',
      deleteUser: 'Șterge Utilizator',
      createUser: 'Creează Utilizator',
      createNewUser: 'Pasul 1: Creează utilizator',
      createUserSubtitle: 'Cont nou și profil de consilier',
      editUserSubtitle: 'Actualizează contul și profilul',
      fullName: 'Nume Complet',
      lastName: 'Nume',
      firstName: 'Prenume',
      email: 'Email',
      role: 'Rol',
      status: 'Status',
      actions: 'Acțiuni',
      name: 'Nume',
      created: 'Creat',
      generatedPassword: 'Parolă Generată',
      passwordHelperText: 'Parola este generată automat pe baza prenumelui și numelui',
      copyCredentials: 'Copiază Credențiale',
      credentialsCopied: 'Credențiale copiate în clipboard',
      createUserSuccessCredentialsCopied:
        'Utilizator creat. Credențialele au fost copiate și trimise pe email.',
      createUserSuccess: 'Utilizator creat. Datele de autentificare au fost trimise pe email.',
      updateUser: 'Actualizează Utilizator',
      adminsCannotModifyLeaders: 'Coordonatorii nu pot modifica conturile liderilor',
      deleteUserTitle: 'Șterge Utilizator',
      deleteUserConfirm: 'Ești sigur că vrei să ștergi permanent acest utilizator? Profilul de consilier asociat va fi eliminat, cazurile atribuite vor reveni în așteptare, iar contul va fi șters din Authentication. Această acțiune nu poate fi anulată.',
      deleteUserSelfConfirm: 'Ești sigur că vrei să te ștergi permanent? Profilul de consilier, cazurile atribuite și contul din Authentication vor fi eliminate. Vei fi deconectat imediat!',
      deactivateUser: 'Dezactivează Utilizator',
      deactivateUserConfirm: 'Ești sigur că vrei să dezactivezi acest utilizator? Nu va putea să se conecteze până când va fi reactivat.',
      cannotDeactivateSelf: 'Nu te poți dezactiva singur',
      adminsCannotDeactivateLeaders: 'Coordonatorii nu pot dezactiva lideri',
      skipCounselorProfile: 'Fără profil de consilier',
      createProfileStepTitle: 'Pasul 2: Creează profilul de consilier',
      createProfileStepHint: 'Completează profilul pentru a putea aloca cazuri acestui utilizator.',
      createUserInProgress: 'Se creează utilizatorul…',
      createUserError: 'Eroare la crearea utilizatorului',
      emailAlreadyInUse: 'Această adresă de email este deja înregistrată',
      emailInvalid: 'Adresa de email este invalidă',
      updateUserSuccess: 'Utilizator actualizat cu succes',
      updateUserError: 'Eroare la actualizarea utilizatorului',
      deleteUserSuccess: 'Utilizator șters cu succes',
      deleteUserError: 'Eroare la ștergerea utilizatorului',
      deleteUserInProgress: 'Se șterge utilizatorul. Poate dura câteva secunde…',
      deactivateUserSuccess: 'Utilizator dezactivat cu succes',
      deactivateUserError: 'Eroare la dezactivarea utilizatorului',
      reactivateUserSuccess: 'Utilizator reactivat cu succes',
      reactivateUserError: 'Eroare la reactivarea utilizatorului',

      accountSection: 'Cont',
      profileSection: 'Profil',
      phoneNumber: 'Telefon',
      phoneHelper: '9 cifre după +40',
      sex: 'Sex',
      sexFemale: 'Feminin',
      sexMale: 'Masculin',
      birthDate: 'Data nașterii',
      specialties: 'Specialități',
      workload: 'Încărcare',
      workloadLow: 'Scăzută',
      workloadModerate: 'Moderată',
      workloadHigh: 'Ridicată',
      /** Visible card meta: Scăzută: 2 */
      workloadCases: '{level}: {count}',
      active: 'Activ',
      inactive: 'Inactiv',
      expandDetails: 'Detalii',
      collapseDetails: 'Ascunde',
      profileDetails: 'Detalii profil',
      editFields: 'Editează câmpurile',
      noProfile: 'Fără profil',
      caseSingular: 'caz',
      casePlural: 'cazuri',
      activeCases: 'Cazuri active',
      contactInfo: 'Contact',
      personalInfo: 'Date personale',
      reactivateUser: 'Reactivează',
      supremeLeaderBadge: 'Lider principal',
      transferSupremeLeader: 'Transferă liderul principal',
      transferSupremeLeaderTitle: 'Transferă liderul principal',
      transferSupremeLeaderConfirm:
        'Ești sigur că vrei să transferi rolul de lider principal acestui utilizator? Nu vei mai putea muta flag-ul după aceea, decât dacă noul lider ți-l returnează.',
      transferSupremeLeaderSuccess: 'Rolul de lider principal a fost transferat',
      transferSupremeLeaderError: 'Eroare la transferul liderului principal',
    },
    cases: {
      searchPlaceholder: 'Caută cazuri după nume, status, tip...',
      filters: {
        status: 'Status',
        issueType: 'Tip Problemă',
        allStatuses: 'Toate Statusurile',
        allIssueTypes: 'Toate Tipurile'
      }
    }
  },

  // Statuses
  status: {
    all: 'Toate Cazurile',
    active: 'Active',
    pending: 'În Așteptare',
    completed: 'Finalizate',
    waiting: 'În Așteptare',
    unfinished: 'Nefinalizate',
    cancelled: 'Anulate'
  },

  // Issue Types
  issueTypes: {
    personal: 'Personală',
    family: 'Familie',
    relational: 'Relațională',
    marriage: 'Căsătorie',
    emotional: 'Emoțional',
    spiritual: 'Spirituală',
    financial: 'Financiar',
    other: 'Altul'
  },

  // Civil Status
  civilStatus: {
    unmarried: 'Necăsătorit/ă',
    single: 'Necăsătorit/ă',
    married: 'Căsătorit/ă',
    divorced: 'Divorțat/ă',
    engaged: 'Logodit/ă',
    widowed: 'Văduv/ă',
    // Gender-specific translations
    masculin: {
      unmarried: 'Necăsătorit',
      married: 'Căsătorit',
      divorced: 'Divorțat',
      engaged: 'Logodit',
      widowed: 'Văduv'
    },
    feminin: {
      unmarried: 'Necăsătorită',
      married: 'Căsătorită',
      divorced: 'Divorțată',
      engaged: 'Logodită',
      widowed: 'Văduvă'
    }
  },

  // Roles
  roles: {
    counselor: 'Consilier',
    admin: 'Coordonator',
    leader: 'Lider',
    leaderDescription: {
      createUsers: 'Creează utilizatori noi cu orice rol (lider, coordonator, consilier)',
      editManageUsers: 'Editează și gestionează toți utilizatorii',
      deactivateReactivateUsers: 'Dezactivează/reactivează orice utilizator',
      deleteUsers: 'Șterge permanent orice utilizator',
      createDeleteCounselorProfiles: 'Creează și șterge profile de consilier',
      manageCounselorsCases: 'Gestionează consilieri, cazuri și consimțăminte',
      fullSystemAccess: 'Acces complet la sistem',
      cannotEditDeleteOwn: 'Nu poți edita sau șterge propriul cont'
    },
    adminDescription: {
      viewAllUsers: 'Vizualizează toți utilizatorii',
      editUsersExceptLeaders: 'Editează utilizatori (cu excepția liderilor)',
      deactivateReactivateExceptLeaders: 'Dezactivează/reactivează utilizatori (cu excepția liderilor)',
      manageCasesEditCounselors: 'Gestionează cazuri și editează profile de consilier',
      accessAdminTools: 'Acces la unelte admin',
      limitedCannotCreateUsers:
        'Limitare: Nu poate crea utilizatori sau profile de consilier, nu poate șterge conturi/profile și nu poate modifica conturile liderilor'
    },
    counselorDescription: {
      viewOwnCasesOnly: 'Vizualizează doar cazurile alocate',
      addMeetingNotes: 'Adaugă note de sesiune pentru cazurile alocate',
      manageOwnAppointments: 'Gestionează propriile programări',
      updateOwnProfile: 'Actualizează propriul profil',
      limitedCannotCreateCases: 'Limitare: Nu poate crea cazuri sau gestiona alți utilizatori'
    }
  },

  // Meeting Notes
  caseProfile: {
    title: 'Descrierea cazului',
    subtitle:
      'Completează ce știi acum. Profilul se îmbogățește pe parcurs — nu trebuie umplut tot de la început.',
    openCta: 'Descrierea cazului',
    editCta: 'Completează descrierea',
    saved: 'Descrierea a fost salvată',
    saveError: 'Eroare la salvarea descrierii',
    requiredMissing: 'Completează cel puțin „De ce a venit".',
    completeness: '{{answered}} din {{total}} întrebări completate',
    lastUpdated: 'Actualizat de {{name}} · {{date}}',
    emptyState: 'Descrierea nu a fost completată încă.',
    optional: 'opțional',
    fields: {
      whyCame: {
        label: 'De ce a venit?',
        helper: 'Motivul spus pentru care a apelat la consiliere.',
      },
      currentSituation: {
        label: 'Ce se întâmplă acum?',
        helper: 'Situația concretă din ultimele săptămâni, ce a declanșat cererea.',
      },
      background: {
        label: 'Ce este în spate?',
        helper:
          'Lucruri care influențează sau contribuie la problemă. Ex: context familial, relații etc.',
      },
      hopes: {
        label: 'Ce speră?',
        helper: 'Ce așteaptă de la consiliere, cum ar arăta pentru persoana consiliata un rezultat bun.',
      },
    },
  },
  meetingNotes: {
    apprenticeBadge: 'Ucenic',
    mentorshipEndedReadOnly:
      'Mentorat încheiat — poți citi cazul, dar nu mai poți modifica notițele.',
    mentorCaseBadge: 'Caz al mentorului {{name}}',
    observerBadge: 'Ucenic: {{names}}',

    title: 'Jurnalul sesiunii',
    pageTitle: 'Jurnalul sesiunii',
    addNote: 'Adaugă Notă',
    editNote: 'Editează Notă',
    deleteNote: 'Șterge Notă',
    deleteNoteConfirm: 'Sigur doriți să ștergeți această notă de sesiune?',
    date: 'Data',
    counselor: 'Consilier',
    content: 'Conținut',
    contentPlaceholder:
      'Descrie cum s-a desfășurat întâlnirea, ce progres a fost făcut, observații importante...',
    sessionField: 'Sesiune',
    sessionLabel: 'Sesiune {n}',
    sessionInProgress: 'Sesiune {n} (în curs)',
    noSession: 'Fără sesiune',
    showingLatest: 'ultimele {n}',
    viewAllOnPage: 'Vezi toate pe Jurnalul sesiunii',
    searchPlaceholder: 'Caută după nume, titlu caz…',
    casesList: 'Cazuri',
    selectCase: 'Selectează un caz pentru a vedea notele',
    noCases: 'Nu există cazuri pentru filtrele selectate',
    noNotesForSession: 'Nu există note pentru această sesiune',
    contentTypeAll: 'Toate',
    contentTypeNote: 'Notă',
    contentTypeTablou: 'Tablou',
    noNotesForContentType: 'Nimic de acest tip pentru sesiunea aleasă',
    previousSessions: 'Sesiuni anterioare',
    nextSessions: 'Sesiuni următoare',
    noteSingular: 'notă',
    notePlural: 'note',
    loadError: 'Eroare la încărcarea notelor de sesiune',
    noNotes: 'Nu există note',
    noNotesMessage: 'Nu există note de sesiune încă. Adaugă prima notă pentru a urmări sesiunile de consiliere.',
    latestNote: 'Ultima Notă de Sesiune',
    latestMeetingNote: 'Ultima Notă de Sesiune',
    viewAllNotes: 'Vezi ultimele note',
    viewLatestNotes: 'Vezi ultimele note',
    allMeetingNotes: 'Toate Notele de Sesiune',
    noMeetingNotesYet: 'Nu există note de sesiune încă',
    noMeetingNotesAdded: 'Nu există note de sesiune adăugate pentru acest caz încă.',
    addNoteSuccess: 'Notă de sesiune adăugată cu succes',
    showMore: 'Afișează mai mult',
    showLess: 'Afișează mai puțin',
    addNoteError: 'Eroare la adăugarea notei de sesiune',
    deleteNoteSuccess: 'Notă de sesiune ștearsă cu succes',
    deleteNoteError: 'Eroare la ștergerea notei de sesiune',
    updateSuccess: 'Notă de sesiune actualizată cu succes'
  },

  // Monthly accountability report (dare de socoteală)
  monthlyReport: {
    title: 'Raport lunar',
    subtitle: 'Formular confidențial de dare de socoteală',
    intro:
      'Acest formular este confidențial și se completează lunar. Scopul lui este creșterea spirituală și sănătatea echipei.',
    reportFor: 'Raport pentru {month}',
    dueWindowHint: 'Te rugăm să trimiți raportul în primele {days} zile ale lunii.',
    yourInfo: 'Datele tale',
    name: 'Nume și prenume',
    email: 'Email',
    sectionSpiritual: 'Viața spirituală',
    relationshipWithGod: 'Cum descrii relația ta cu Dumnezeu în ultima perioadă?',
    mostAliveDiscipline: 'Care disciplină spirituală a fost cea mai vie pentru tine luna aceasta?',
    disciplineNeedsStrengthening: 'Care domeniu (disciplină) are nevoie de întărire?',
    sectionRelationships: 'Relații',
    maritalStatus: 'Stare civilă',
    married: 'Căsătorit(ă)',
    unmarried: 'Necăsătorit(ă)',
    marriageFamilyNotes: 'Dacă ești căsătorit(ă): cum apreciezi relația cu soțul/soția și familia?',
    closeRelationshipsNotes:
      'Dacă nu ești căsătorit(ă): cum merg relațiile apropiate (prieteni, curtenie)?',
    needsPersonalRelationshipSupport: 'Ai nevoie de sprijin într-o relație personală?',
    sectionSelfCare: 'Îngrijirea personală',
    heartState: 'Cum apreciezi starea inimii tale?',
    feelsTiredOrBurdened: 'Te simți obosit(ă) sau împovărat(ă)?',
    howLeaderOrTeamCanHelp: 'Este un mod în care liderul sau echipa poate să îți vină în ajutor?',
    departmentImprovements:
      'Ce crezi că ar fi benefic pentru departament să fie îmbunătățit, schimbat sau adăugat, astfel încât această slujire să fie mai eficientă?',
    submit: 'Trimite raportul',
    submitSuccess: 'Raportul lunar a fost trimis cu succes',
    submitError: 'Eroare la trimiterea raportului',
    loadError: 'Eroare la încărcarea raportului lunar',
    alreadySubmitted: 'Ai trimis deja raportul pentru această lună',
    submittedAt: 'Trimis pe {date}',
    required: 'Câmp obligatoriu',
    leaderTitle: 'Rapoarte primite',
    leaderSubtitle: 'Vizualizează dările de socoteală ale echipei',
    selectMonth: 'Luna raportată',
    noSubmissions: 'Nu există rapoarte pentru această lună',
    viewReport: 'Vezi raport',
    submissionsCount: '{count} rapoarte',
    downloadPdf: 'Descarcă PDF',
    downloadingPdf: 'Se generează PDF…',
    downloadPdfError: 'Eroare la generarea PDF-ului',
    backToForm: 'Înapoi la formularul meu',
  },

  resources: {
    title: 'Resurse',
    subtitle: 'Documente, prezentări, audio și video ale departamentului.',
    accessHint:
      'Dacă nu aveți acces la un fișier, vă rugăm să cereți acces liderului.',
    addFolder: 'Adaugă folder',
    addSubfolder: 'Adaugă subfolder',
    addLink: 'Adaugă link',
    editFolder: 'Editează folder',
    editSubfolder: 'Editează subfolder',
    editLink: 'Editează link',
    folderName: 'Nume folder',
    subfolderName: 'Nume subfolder',
    parentFolder: 'Folder părinte',
    rootFolder: 'Folder rădăcină',
    allowCounselors: 'Vizibil pentru consilieri',
    allowAdmins: 'Vizibil pentru coordonatori',
    folderColor: 'Culoare folder',
    maxDepthError: 'Nu poți adăuga mai mult de {max} niveluri de foldere',
    linkTitle: 'Titlu',
    linkUrl: 'URL (Docs / Sheets / PowerPoint / PDF / Audio / Video)',
    linkKind: 'Tip',
    kindDoc: 'Document',
    kindSheet: 'Foaie de calcul',
    kindPowerpoint: 'PowerPoint',
    kindPdf: 'PDF',
    kindAudio: 'Audio',
    kindVideo: 'Video',
    kindOther: 'Alt link',
    folder: 'Folder',
    noFoldersYet: 'Creează mai întâi un folder',
    linkOpensExternal: 'Linkul se deschide într-o filă nouă în Google.',
    openInGoogle: 'Deschide în Google',
    empty: 'Nu există resurse vizibile',
    emptyHint: 'Când liderul sau coordonatorul adaugă foldere și linkuri, le vei vedea aici.',
    emptyFolder: 'Niciun link în acest folder',
    loadError: 'Eroare la încărcarea resurselor',
    saveError: 'Eroare la salvare',
    folderNameRequired: 'Numele folderului este obligatoriu',
    linkTitleRequired: 'Titlul este obligatoriu',
    invalidUrl: 'Introdu un URL valid (ex. docs.google.com)',
    invalidParent: 'Folderul părinte selectat nu este valid',
    folderRequired: 'Selectează un folder',
    deleteFolderTitle: 'Șterge folder',
    deleteFolderConfirm: 'Sigur vrei să ștergi folderul „{name}”?',
    deleteFolderWarning: 'Subfolderele și toate linkurile din interior vor fi șterse definitiv.',
    deleteLinkTitle: 'Șterge link',
    deleteLinkConfirm: 'Sigur vrei să ștergi linkul „{name}”?',
    chipCounselors: 'Consilieri',
    chipAdmins: 'Coordonatori',
    chipLeadersOnly: 'Doar lideri',
    expand: 'Extinde',
    collapse: 'Restrânge',
    dropLinkHere: 'Eliberează pentru a muta aici',
    searchLabel: 'Caută resurse',
    searchPlaceholder: 'Caută după titlu sau folder…',
    clearSearch: 'Șterge căutarea',
    searchResultSingular: 'rezultat',
    searchResultPlural: 'rezultate',
    searchNoResults: 'Nicio resursă găsită',
    searchNoResultsHint: 'Încearcă alt cuvânt sau alege alt tip de fișier.',
    searchSectionFolders: 'Foldere',
    searchSectionLinks: 'Linkuri',
    openFolderInTree: 'Deschide folderul în listă',
    linkCountSingular: 'link',
    linkCountPlural: 'linkuri',
    folderCountSingular: 'folder',
    folderCountPlural: 'foldere',
    emptyFolderShort: 'gol',
    filterAllKinds: 'Toate',
    kindShort: {
      doc: 'Document',
      sheet: 'Calcul',
      powerpoint: 'Prezentare',
      pdf: 'PDF',
      audio: 'Audio',
      video: 'Video',
      other: 'Link',
    },
  },

  // Validation Errors
  validation: {
    required: 'Acest câmp este obligatoriu',
    emailInvalid: 'Adresa de email este invalidă',
    passwordTooShort: 'Parola este prea scurtă',
    phoneInvalid: 'Numărul de telefon este invalid'
  },

  // Time
  time: {
    today: 'Astăzi',
    yesterday: 'Ieri',
    tomorrow: 'Mâine',
    now: 'Acum',
    justNow: 'Acum',
    minutesAgo: 'minute în urmă',
    hoursAgo: 'ore în urmă',
    daysAgo: 'zile în urmă',
    weeksAgo: 'săptămâni în urmă',
    monthsAgo: 'luni în urmă'
  }
};

